<template>
  <van-cell-group
    :border="false"
    class="publish-form-card"
    :class="{ 'publish-form-card--expanded': expanded }"
  >
    <slot />
  </van-cell-group>
</template>

<script>
export default {
  name: "PublishFormCard",
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
@import "./tokens.less";

.publish-form-card {
  position: relative;
  overflow: visible;
  background: @publish-surface;
  border-radius: @publish-radius-card;

  &::after {
    display: none;
  }

  & + & {
    margin-top: 11px;
  }
}

.publish-form-card.product-info-card {
  overflow: hidden;
  border-radius: 11px;
}
</style>
